import { Pipe, PipeTransform } from '@angular/core';
import { ErrorModels } from 'models/error.model';

@Pipe({ name: 'wzError', standalone: false })
export class ErrorPipe implements PipeTransform {
  constructor() {}
  transform(error: string | ErrorModels.TunnelSanteError): string {
    if (typeof error === 'string') {
      return error;
    } else {
      return error.appMessage;
    }
  }
}
